import React from 'react';
import BadgeImage from '@components/Tiers/BadgeImage';
import { Tooltip } from '@components/main-components/tooltip/Tooltip';
import { MediaQuery } from '@context/mediaQuery';
import { TIERS } from '@utils/tiers';

export const CollectedBadge = ({
  type = TIERS.FOREVER,
  tooltipContent,
}: {
  type?: TIERS | 'goldenEgg';
  tooltipContent: string;
}) => {
  const { tabletLandscape } = MediaQuery.useContainer();

  return (
    <Tooltip openOnClick={false}>
      <Tooltip.Trigger>
        <div className="w-8 text-base800 hover:cursor-pointer">
          <BadgeImage type={type} />
        </div>
      </Tooltip.Trigger>
      <Tooltip.StyledContent size="sm" side={!tabletLandscape ? 'left' : 'top'}>
        {tooltipContent}
      </Tooltip.StyledContent>
    </Tooltip>
  );
};
